import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import createStore, { rrfbConfig } from './configureStore'
import { ModalProvider } from 'shared/hooks/useModal'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import Root from 'app/Root'
import React from 'react'
import './index.less'

const store = createStore()
const config = rrfbConfig(store)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...config}>
      <ModalProvider>
        <Root />
      </ModalProvider>
    </ReactReduxFirebaseProvider>
  </Provider>
)
